
import { css } from 'lit';
export default css`
pc-teaser-card a{
    background-image:linear-gradient(
      transparent calc(100% - 2px),
      var(--primary-eggplant) 2px
    );
    background-repeat:no-repeat;
    background-size:0 100%;
    transition:background-size 0.3s;
    padding:0.25rem 0rem;
    display:inline !important;
  }
  pc-teaser-card a:focus,
  pc-teaser-card a:hover{
    color:var(--purple-indigo);
  }
  pc-teaser-card [slot='title'] a::after{
    content:'';
    position:absolute;
    inset:0;
  }
  pc-teaser-card [slot='image']{
    display:flex;
  }
  pc-teaser-card [slot='image'] img{
      width:100%;
      height:100%;
      object-fit:cover;
      transition:scale ease-in-out 0.5s;
    }
pc-teaser-card [slot='contents'][footer],
pc-teaser-card [slot='title'][footer]{
  color:var(--neutral-charcoal);
  font-family:var(--ff-body);
  font-size:var(--fs-body-mobile);
  font-style:normal;
  font-weight:400;
  line-height:var(--lh-body-mobile);
}
@media (min-width: 992px){
pc-teaser-card [slot='contents'][footer],
pc-teaser-card [slot='title'][footer]{
    font-size:var(--fs-body);
    line-height:var(--lh-body)
}
  }
pc-teaser-card[hovered='hovered'] [slot='image'] img{
    scale:1.1;
  }
`;